export const PRINT_OUTCOME_UNKNOWN_ERROR_CODE = "HARDWARE_BRIDGE_PRINT_OUTCOME_UNKNOWN" as const
export const PRINT_RECONCILE_REQUIRED_ERROR_CODE = "HARDWARE_BRIDGE_PRINT_RECONCILE_REQUIRED" as const

export class PrintOutcomeUnknownError extends Error {
  readonly code = PRINT_OUTCOME_UNKNOWN_ERROR_CODE

  constructor(readonly jobId: string, message: string) {
    super(message)
    this.name = "PrintOutcomeUnknownError"
  }
}

export class HardwareBridgeFeatureUnsupportedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "HardwareBridgeFeatureUnsupportedError"
  }
}

export function isPrintOutcomeUnknownError(error: unknown): error is PrintOutcomeUnknownError {
  return error instanceof PrintOutcomeUnknownError
    || (typeof error === "object"
      && error !== null
      && "code" in error
      && error.code === PRINT_OUTCOME_UNKNOWN_ERROR_CODE)
}

export class PrintReconcileRequiredError extends Error {
  readonly code = PRINT_RECONCILE_REQUIRED_ERROR_CODE

  constructor(readonly jobId: string, message: string) {
    super(message)
    this.name = "PrintReconcileRequiredError"
  }
}

export function isPrintReconcileRequiredError(error: unknown): error is PrintReconcileRequiredError {
  return error instanceof PrintReconcileRequiredError
    || (typeof error === "object"
      && error !== null
      && "code" in error
      && error.code === PRINT_RECONCILE_REQUIRED_ERROR_CODE)
}
